import Vue from "@/main";
import eventService from "../../../events/services/eventService";

const types = [
    { name: "sms", description: "СМС", params: ["text"] },
    { name: "email", description: "Email", params: [] },
    { name: "push", description: "Пуши", params: ["text"] },
];

const contents = [
    { name: "offer", description: "Оффер", params: ["offer_id", "source"] },
    { name: "showcase", description: "Витрина", params: ["source"] },
];

function pad(num) {
    return ("0" + num).slice(-2);
}
function convertSeconds(secs) {
    var minutes = Math.floor(secs / 60);
    secs = secs % 60;
    var hours = Math.floor(minutes / 60);
    minutes = minutes % 60;
    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}

export default {
    getTypes() {
        return types;
    },
    getTypeByName(name) {
        return types.find((type) => type.name == name);
    },
    getTypeByDescription(description) {
        return types.find((type) => type.description == description);
    },

    getContentTypes() {
        return contents;
    },
    getContentTypeByName(name) {
        return contents.find((type) => type.name == name);
    },
    getContentTypeByDescription(description) {
        return contents.find((type) => type.description == description);
    },

    getAdditionalParams(typeName, contentName) {
        let params = [];
        const type = types.find((item) => item.name == typeName);
        const content = contents.find((item) => item.name == contentName);
        return params.concat(type.params, content.params);
    },

    parseTriggerList(triggers) {
        triggers.forEach((trigger) => {
            trigger.eventFormatted = eventService.translateEvent(trigger.event);
            trigger.typeFormatted = this.getTypeByName(trigger.notification_type).description;
            trigger.contentFormatted = this.getContentTypeByName(trigger.content_type).description;
            trigger.delayFormatted = convertSeconds(trigger.delay);
            trigger.descriptionFormatted = Vue.$options.filters.truncate(trigger.description, 15);
        });

        return triggers;
    },
};
